export const IconGoogleCalendar30: {
  name: 'icon_google_calendar_30-613ac42c13b8'
} = {
  name: 'icon_google_calendar_30-613ac42c13b8'
}
